import {baseConfig} from '../helpers/baseConfig'
import {BRAND_LABEL} from '../../../../../app/brand'

export const cardConfig = (props) => {
    const isRegistered = props?.isCustomerRegistered
    const placeholders = props?.placeholders || {
        cardNumber: '1234 5678 9012 3456',
        expiryDate: 'MM/YY',
        securityCode: '3 digits',
        securityCodeThreeDigits: '3 digits',
        securityCodeFourDigits: '4 digits',
        holderName: 'J. Smith',
    }
    return {
        ...baseConfig(props),
        showPayButton: true,
        hasHolderName: true,
        holderNameRequired: true,
        billingAddressRequired: false,
        enableStoreDetails: isRegistered,
        placeholders,
        clickToPayConfiguration: {
            merchantDisplayName: props?.merchantDisplayName || BRAND_LABEL,
            shopperEmail: props?.basket?.customerInfo?.email || props?.customerEmail,
        },
    }
}
